import React from "react";
import { _t } from "../../app/i18n/i18n";

export const PublicFaqHeader = () => (
  <div className="mb-4">
    <h1 className="font-weight-bold mb-3" style={{ fontSize: '28px' }}>
      NOMURA Global Research Portal: {_t("FAQ")}
    </h1>
    <p className="mb-0">
      {_t("FAQ support msg1")}
      <a href="mailto:grpsupport@nomura.com" className="text-primary">
        {_t("GRP Support")}
      </a>
      {_t("FAQ support msg2")}
    </p>
  </div>
);